<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-coupon-level-dialog-form">
    <b>Coupon Code:</b> {{ data.couponCode }}<br />
    <mat-label>Applies To</mat-label>
    <mat-radio-group name="LevelType" [(ngModel)]="LevelType">
      <mat-radio-button value="Interactive"
        >Interactive&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
      >
      <mat-radio-button value="Xmla"
        >XMLA Connection&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
      > </mat-radio-group
    ><br />

    <mat-form-field *ngIf="LevelType == 'Interactive'">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        (selectionChange)="updateInteractiveType()"
        name="data.interactSubscriptionTypeId"
        style="width: 100%"
        [(ngModel)]="data.interactSubscriptionTypeId"
      >
        <mat-option
          *ngFor="let subType of data.interactSubscriptionTypes"
          [value]="subType.interactSubTypeId"
          >{{ subType.interactSubTypeName }}</mat-option
        >
      </mat-select> </mat-form-field
    ><br />
    <mat-form-field *ngIf="LevelType == 'Interactive'">
      <mat-label>Subscription Level</mat-label>
      <mat-select
        name="data.interactSubscriptionLevelId"
        style="width: 100%"
        [(ngModel)]="data.interactSubscriptionLevelId"
      >
        <mat-option
          *ngFor="let subLevel of filteredSubLevels"
          [value]="subLevel.interactSubLevelId"
          >{{ subLevel.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="LevelType == 'Xmla'">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        (selectionChange)="updateXmlaType()"
        name="data.xmlaSubscriptionTypeId"
        style="width: 100%"
        [(ngModel)]="data.xmlaSubscriptionTypeId"
      >
        <mat-option
          *ngFor="let subType of data.xmlaSubscriptionTypes"
          [value]="subType.xmlaSubscriptionTypeId"
          >{{ subType.xmlaSubscriptionName }}</mat-option
        >
      </mat-select> </mat-form-field
    ><br />
    <mat-form-field *ngIf="LevelType == 'Xmla'">
      <mat-label>Subscription Level</mat-label>
      <mat-select
        name="data.xmlaSubscriptionLevelId"
        style="width: 100%"
        [(ngModel)]="data.xmlaSubscriptionLevelId"
      >
        <mat-option
          *ngFor="let subLevel of filteredXmlaSubscriptionLevels"
          [value]="subLevel.xmlaSubscriptionLevelId"
          >{{ subLevel.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Coupon Level
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
